import React, { useEffect, useState } from 'react'
import './Mobile.sass'
import LOGO from '../../resources/imgs/fm-world-onlycircle.svg'
import SEARCH from '../../resources/icons/search-icon.svg'
import CLOSE from '../../resources/icons/close-icon.svg'
import { getFmFrequencies, getNews, getRadios, getRandomNews } from '../../resources/api-constants'
import axios from 'axios'
import he from 'he'
import Loader from '../../components/Loader/Loader'
import { Article, Frequency, Radio } from '../../types/data'
import moment from 'moment'
import 'moment/locale/it'
import FmWorldAxios from '../../utility/FmWorldAxios'
import { convertFrequencyFetched, sortArrayPerFrequency } from '../../utility/functions'
import { useTimeout } from '../../utility/hooks'
moment.locale('it')

const Mobile: React.FC = () => {
    const [currentTimeout, setCurrentTimeout] = useState<null | number>(null)
    const [search, setSearch] = useState('')
    const [isLoadingNews, setIsLoadingNews] = useState(false)
    const [news, setNews] = useState<Article[]>([])
    const [suggestedNews, setSuggestedNews] = useState<Article[]>([])
    const [isLoadingFrequencies, setIsLoadingFrequencies] = useState(false)
    const [frequencies, setFrequencies] = useState<Frequency[]>([])
    const [isLoadingRadios, setIsLoadingRadios] = useState(false)
    const [radios, setRadios] = useState<Radio[]>([])

    const cleanContent = (content: string) => {
        // Rimuove il link "Read More" e qualsiasi altro tag HTML indesiderato
        return content.replace(/<a class="cz_readmore[^>]*>.*?<\/a>/g, '').replace(/<\/?[^>]+(>|$)/g, '')
    }

    const fetchNews = async () => {
        setIsLoadingNews(true)
        const params = {
            search,
        }
        const newsFetched = await axios
            .get(getNews(), {
                params: { ...params },
                headers: { 'Cache-Control': 'no-cache' },
            })
            .then((res) => {
                const data = res.data
                return data.map((d: any) => {
                    return {
                        id: d.id,
                        date: d.date,
                        title: he.decode(d.title),
                        content: he.decode(cleanContent(d.excerpt)),
                        categories:
                            d.categories.length > 0
                                ? d.categories
                                      .filter((t: any) => t.taxonomy === 'category')
                                      .map((t: any) => {
                                          return {
                                              id: t.link,
                                              name: t.name,
                                          }
                                      })
                                : [],
                        img: d.image,
                        url: d.link,
                    }
                })
            })
        setNews(newsFetched)
        setIsLoadingNews(false)
    }

    const fetchRandomNews = async () => {
        setIsLoadingNews(true)
        const newsFetched = await axios
            .get(getRandomNews(), {
                headers: { 'Cache-Control': 'no-cache' },
            })
            .then((res) => {
                const data = res.data
                return data.map((d: any) => {
                    return {
                        id: d.id,
                        date: d.date,
                        title: he.decode(d.title),
                        content: he.decode(cleanContent(d.excerpt)),
                        categories:
                            d.categories.length > 0
                                ? d.categories
                                      .filter((t: any) => t.taxonomy === 'category')
                                      .map((t: any) => {
                                          return {
                                              id: t.link,
                                              name: t.name,
                                          }
                                      })
                                : [],
                        img: d.image,
                        url: d.link,
                    }
                })
            })
        setSuggestedNews(newsFetched)
        setIsLoadingNews(false)
    }

    const fetchFrequenciesLocal = async () => {
        setIsLoadingFrequencies(true)
        try {
            const params: any = {
                countries: 'IT',
                query: search,
            }
            const frequenciesFetch = await FmWorldAxios.get(getFmFrequencies(), {
                params: { ...params },
            }).then((res) => {
                const frequencies = res.data.items.map((f: any) => {
                    return convertFrequencyFetched(f)
                })
                const sortedFrequncy = sortArrayPerFrequency(frequencies)
                return sortedFrequncy
            })
            setFrequencies(frequenciesFetch)
        } catch (error: any) {
            console.log('ERROR', error)
        }
        setIsLoadingFrequencies(false)
    }

    const fetchRadios = async () => {
        setIsLoadingRadios(true)
        try {
            const params = {
                query: search,
                countries: 'IT',
            }
            const radiosFetch = await FmWorldAxios.get(getRadios(), { params: { ...params } }).then((res) => {
                return res.data.items
            })
            setRadios(radiosFetch)
        } catch (error: any) {
            console.log(error)
        }
        setIsLoadingRadios(false)
    }

    useEffect(() => {
        if (search) {
            setNews([])
            setRadios([])
            setFrequencies([])
            if (currentTimeout) {
                setCurrentTimeout(null)
            }

            setCurrentTimeout(1000)
        }
    }, [search])

    useTimeout(async () => {
        void fetchNews()
        void fetchRadios()
        void fetchFrequenciesLocal()
        setCurrentTimeout(null)
    }, currentTimeout)

    useEffect(() => {
        void fetchRandomNews()
    }, [])

    const renderNews = () => {
        if (search) {
            return (
                <div>
                    <h2 className="title">News trovate</h2>
                    {isLoadingNews ? <Loader /> : null}
                    {news.length > 0 ? (
                        <>
                            <div>
                                {news
                                    .filter((_, i) => i < 4)
                                    .map((n) => {
                                        return (
                                            <div className="article" key={n.id}>
                                                <div className="article-columnImg">
                                                    <a href={n.url}>
                                                        <img
                                                            src={n.img}
                                                            alt={n.title}
                                                            className="article-columnImg--image"
                                                        />
                                                    </a>
                                                </div>
                                                <div className="article-data">
                                                    <a href={n.url}>
                                                        <h3 className="article-data--title">{n.title}</h3>
                                                    </a>
                                                    <p className="article-data--content">{n.content}</p>
                                                    <p className="article-data--date">{n.date}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                            <div className="actionRow">
                                <a
                                    className="showMoreButton"
                                    href={`https://fm-world.it/risultati-ricerca?type=news&query=${search}`}
                                >
                                    Leggi tutte le news trovate
                                </a>
                            </div>
                        </>
                    ) : null}
                    {news.length === 0 && !isLoadingNews ? <p className="nothingFound">Nessuna news trovata</p> : null}
                </div>
            )
        }
        return (
            <div>
                <h2 className="title">News suggerite</h2>
                {isLoadingNews ? <Loader /> : null}
                {suggestedNews.length > 0 ? (
                    <div>
                        {suggestedNews.map((n) => {
                            return (
                                <div className="article" key={n.id}>
                                    <div className="article-columnImg" onClick={() => (location.href = n.url)}>
                                        <a href={n.url}>
                                            <img src={n.img} alt={n.title} className="article-columnImg--image" />
                                        </a>
                                    </div>
                                    <div className="article-data">
                                        <a href={n.url}>
                                            <h3 className="article-data--title">{n.title}</h3>
                                        </a>
                                        <p className="article-data--content">{n.content}</p>
                                        <p className="article-data--date">{n.date}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                ) : null}
            </div>
        )
    }

    const renderFrequencies = () => {
        if (search) {
            return (
                <div>
                    <h2 className="title">Frequenze trovate</h2>
                    {isLoadingFrequencies ? <Loader /> : null}
                    {frequencies.length > 0 ? (
                        <>
                            <div className="frequenciesGrid">
                                {frequencies
                                    .filter((_, i) => i < 6)
                                    .map((f) => {
                                        return (
                                            <div key={f.id} className="frequency">
                                                <div className="frequency-columnImg">
                                                    <img
                                                        className="frequency-columnImg--image"
                                                        src={f.radio.logo}
                                                        alt={f.radio.name}
                                                    />
                                                </div>
                                                <div className="frequency-data">
                                                    <div className="frequency-data--frequencyData">
                                                        <label>Frequenza</label>
                                                        <div className="frequency-data--frequencyData_frequency">
                                                            <span className="frequency-data--frequencyData_frequency__number">
                                                                {f.frequency.toFixed(2)}
                                                            </span>{' '}
                                                            <span className="frequency-data--frequencyData_frequency__unit">
                                                                MHz
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="frequency-data--cityData">
                                                        <label>Città</label>
                                                        <p>{f.city.name}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                            <div className="actionRow">
                                <a
                                    className="showMoreButton"
                                    href={`https://new.fm-world.it/risultati-ricerca?type=frequencies&query=${search}`}
                                >
                                    Vedi tutte le frequenze trovate
                                </a>
                            </div>
                        </>
                    ) : null}
                    {frequencies.length === 0 && !isLoadingFrequencies ? (
                        <p className="nothingFound">Nessuna frequenza trovata</p>
                    ) : null}
                </div>
            )
        }
        return null
    }

    const renderRadios = () => {
        if (search) {
            return (
                <div>
                    <h2 className="title">Radio trovate</h2>
                    {isLoadingRadios ? <Loader /> : null}
                    {radios.length > 0 ? (
                        <>
                            <div className="radiosGrid">
                                {radios
                                    .filter((_, i) => i < 6)
                                    .map((r) => {
                                        return (
                                            <div key={r.id} className="radio">
                                                <div className="radio-columnImg">
                                                    <img className="radio-columnImg--image" src={r.logo} alt={r.name} />
                                                </div>
                                                <div className="radio-data">
                                                    <div className="radio-data--radioData">
                                                        <label>Nome & Slogan</label>
                                                        <p>
                                                            {r.name}
                                                            {r.slogan ? ` - ${r.slogan}` : null}
                                                        </p>
                                                    </div>
                                                    {r.categories.length > 0 ? (
                                                        <div className="radio-data--categoryData">
                                                            <label>Categorie</label>
                                                            <p>
                                                                {r.categories.map((c, i) => {
                                                                    return (
                                                                        <span key={c.id}>
                                                                            {c.value}{' '}
                                                                            {i < r.categories.length - 1 ? ', ' : ''}
                                                                        </span>
                                                                    )
                                                                })}
                                                            </p>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                            <div className="actionRow">
                                <a
                                    className="showMoreButton"
                                    href={`https://new.fm-world.it/risultati-ricerca?type=radios&query=${search}`}
                                >
                                    Vedi tutte le radio trovate
                                </a>
                            </div>
                        </>
                    ) : null}
                    {frequencies.length === 0 && !isLoadingFrequencies ? (
                        <p className="nothingFound">Nessuna frequenza trovata</p>
                    ) : null}
                </div>
            )
        }
        return null
    }

    return (
        <div style={{ paddingBottom: 50 }}>
            <div className="header">
                <a href="https://new.fm-world.it">
                    <img src={LOGO} className="logo" alt="logo" />
                </a>

                <img src={SEARCH} className="search" alt="search" />
                <form className="form">
                    <input
                        value={search ? `Ricerca: ${search}` : ''}
                        placeholder="Ricerca radio, frequenze o news"
                        onChange={(e) => setSearch(e.target.value.replace('Ricerca: ', ''))}
                    />
                </form>
                <img
                    src={CLOSE}
                    className="close"
                    alt="close"
                    onClick={() => {
                        setSearch('')
                        if (window.top) {
                            window.top.postMessage('hideSearch', '*')
                        }
                        setSuggestedNews([])
                        void fetchRandomNews()
                    }}
                />
            </div>
            {renderNews()}
            {renderFrequencies()}
            {renderRadios()}
        </div>
    )
}

export default Mobile
